export default "__VITE_ASSET__0017262c__"